export default __webpack_public_path__ + "static/media/Anuncio.71f3c9dc.svg";